import MuxPlayer from "@mux/mux-player-react";
import { motion } from "framer-motion";

const Video = () => {
  return (
    <div className="relative w-full bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400">
      <div className="absolute inset-0 bg-black/5" />
      <div className="relative container mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="desktop:max-w-4xl laptop:max-w-3xl tablet:max-w-2xl mobile:max-w-full mx-auto"
        >
          <div className="w-full aspect-video rounded-xl overflow-hidden shadow-xl">
            <MuxPlayer
              streamType="on-demand"
              playbackId="Ovjh3cvlZ00n637SbnI8PKGsdg29nUrPAgDUHI2002Ego"
              metadata={{
                video_title: "Landing Page Video",
              }}
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Video;
